import { Dispatch } from 'redux';
import { PayloadAction } from '@reduxjs/toolkit';

const InterceptorMiddleware = () => (next: Dispatch) => (action: PayloadAction) => {
  // Here you have access to `action.type` and `action.payload`
  // You should always do this at the end of your middleware

  return next(action);
};

export default InterceptorMiddleware;
